import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Branch} from '../interface/branch';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/branch/${id}`);
  }
  getCollection(): Observable<Branch[]>{
    return this.http.get<Branch[]>(`${this.baseUrl}/get/branches`);
  }
  getEnableCollection(): Observable<Branch[]>{
    return this.http.get<Branch[]>(`${this.baseUrl}/get/enable/branches`);
  }
  getCurrentUserBranchesCollection(): Observable<Branch[]>{
    return this.http.get<Branch[]>(`${this.baseUrl}/get/current/user/branches`);
  }

  post(data: any): Observable<any>{
    return this.http.post<Branch>(`${this.baseUrl}/create/branch`, data);
  }

  put(id: number, data: Branch): Observable<any>{
    return this.http.put<Branch>(`${this.baseUrl}/edit/branch/${id}`, data);
  }

  delete(id: number): Observable<Branch>{
    return this.http.delete<Branch>(`${this.baseUrl}/delete/branch/` + id);
  }

  deleteMultipleBranches(ids: number[]): Observable<Branch[]>{
    const options = {body: ids};
    return this.http.delete<Branch[]>(`${this.baseUrl}/delete/selected/branches`, options);
  }
}
